export default __webpack_public_path__ + "static/media/uiux-selected.85106f46.svg";